export function removeFilesByName(fileList, filesToRemove) {
  const dataTransfer = new DataTransfer();
  const removeSet = new Set(filesToRemove);

  Array.from(fileList).forEach(file => {
    if (!removeSet.has(file.name)) {
      dataTransfer.items.add(file);
    }
  });

  return dataTransfer.files;
}
